import { render, staticRenderFns } from "./UploadImagensDialog.vue?vue&type=template&id=8f225a58&"
import script from "./UploadImagensDialog.vue?vue&type=script&lang=js&"
export * from "./UploadImagensDialog.vue?vue&type=script&lang=js&"
import style0 from "./UploadImagensDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports